module.exports = __webpack_public_path__ + "img/method-man-right.8782c866.png";